// Action key that carries Native call info interpreted by this Redux middleware.
export const TockNative = 'TockNative';
